import { Component, OnInit, ViewChild } from '@angular/core';
import { config } from 'app/constants';
import { DataService, FormatService, HelperService, HTTPService } from 'app/services';
import { Table } from 'primeng/table';

import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'add-tire-storage',
  templateUrl: './add-tire-storage.component.html',
  styleUrls: ['./add-tire-storage.component.scss'],
  providers: [DialogService],
})
export class AddTireStorageModal implements OnInit {
  @ViewChild('dt') table: Table;
  isLoading: boolean = true;
  cols = [
    { title: 'Location', field: 'storageLocation', class: 'location' },
    { title: 'TS#', field: 'externalId', class: 'externalId' },
    { title: 'Name', field: 'title', class: 'name' },
    { title: 'Seasonality', field: 'seasonality', class: 'group' },
    { title: 'Rims', field: 'rimType', class: 'group' },
    { title: 'Tire label', field: 'tireLabel', class: 'group' },
    { title: 'Tread depth', field: 'treadDepth', class: 'group' },
    { title: 'Should replace?', field: 'recommendReplacement', class: 'date' },
    { title: 'Storage date', field: 'dateOfStorage', class: 'date' },
    { title: 'Storage RO #', field: 'storageRO', class: 'date' },
    { title: 'Return RO', field: 'removalRO', class: 'date' },
    { title: 'Return date', field: 'dateOfRemoval', class: 'date' },
  ];
  recordsPerPage: number = config.pageSize;
  searchQuery: string;
  activeStatus: any = true;
  stockStatus: any = 'all';
  isSearching: boolean = false;
  tableConfig = {
    offset: 1,
    limit: config.pageSize,
    sortField: 'title',
    sortOrder: 1,
    search: '',
  };
  filterOptions = {
    status: true,
    stock: false,
  };
  isTireSelected: boolean = false;
  totalRecords: number = 0;
  records = [];
  tireStorage;
  customer: any = {};
  vehicle: any = {};
  currentStorage: any[] = [];
  pastStorage: any[] = [];
  selectedTireStorage: any = {};
  isSwappingTire: boolean = false;
  isRemovingTire: boolean = false;
  isAddingTire: boolean = false;

  constructor(
    private dialogRef: DynamicDialogRef,
    private helperService: HelperService,
    public dataService: DataService,
    private httpService: HTTPService,
    private dialogConfig: DynamicDialogConfig,
    private formatService: FormatService
  ) {}

  ngOnInit() {
    const { customer, vehicle } = this.dialogConfig.data;

    if (customer.customerId && vehicle.vehicleId) {
      this.customer = customer;
      this.vehicle = vehicle;
      this.isLoading = true;
      this.httpService
        .getVehicleTireStorage({ customerId: customer.customerId, vehicleId: vehicle.vehicleId })
        .then(
          (tireStorage: any[]) => {
            if (tireStorage && tireStorage.length >= 0) {
              tireStorage.forEach(({ _id: tireStorageStatus, tires }) => {
                if (tireStorageStatus === 'store') {
                  this.currentStorage = this.formatService.formatTireStorageHistory(tires);
                } else {
                  this.pastStorage = this.formatService.formatTireStorageHistory(tires);
                }
              });
            }
          },
          (err) => {
            this.helperService.showToaster('error', err);
          }
        )
        .finally(() => {
          this.isLoading = false;
        });
    }
  }

  getSelectedTireStorage(tireStorageId = '') {
    if (tireStorageId) {
      let found = false;
      if(this.selectedTireStorage[tireStorageId] === tireStorageId){
        found = true;
      }
      return found;
    }
    return false;
  }

  onSelectTire(tireStorageId: string, isChecked: boolean) {
    if (isChecked) {
      this.selectedTireStorage[tireStorageId] = tireStorageId;
    } else {
      delete this.selectedTireStorage[tireStorageId];
    }

    this.isTireSelected = !!Object.keys(this.selectedTireStorage).length;
  }

  openEstimate(orderId: string) {
    this.helperService.openPageInNewExistingTab(`/estimate/${orderId}`, orderId);
  }

  closeDialog(isSuccess: boolean = false, data: any = {}) {
    this.dialogRef.close({ isSuccess, data });
  }

  handleAddingTire() {
    if (this.isAddingTire) return;

    const data = {
      customerId: this.customer.customerId,
      vehicleId: this.vehicle.vehicleId,
      tireStorageIds: [],
      createType: 'addTire',
      tireSwape: true
    };

    this.isAddingTire = true;
    this.httpService
      .createTireStorageEstimate(data)
      .then(
        (order: any) => {
          if (order) {
            const queryParams = {
              browserSessionToken: order.restriction.token || '',
              checkPreferredLocation: order.checkPreferredLocation || false,
              isisAddTireStorageField: true
            };
            
            const url = this.helperService.constructQueryParams(`/estimate/${order._id}`, queryParams);
            this.helperService.openPageInNewExistingTab(url, order._id);
            this.postTireStorageCustomEvent('Add tires', order);
            // this.helperService.openPageInNewExistingTab(`${config.redirectUrl.estimate}/${order._id}?isAddTireStorageField=true`, order._id);
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isAddingTire = false;
      });
  }

  handleSwapTire() {
    if (this.isSwappingTire) return;

    const data = {
      customerId: this.customer.customerId,
      vehicleId: this.vehicle.vehicleId,
      tireStorageIds: Object.keys(this.selectedTireStorage),
      createType: 'swap',
      tireSwape: true
    };

    this.isSwappingTire = true;
    this.httpService
      .createTireStorageEstimate(data)
      .then(
        (order: any) => {
          if (order) {
            const queryParams = {
              browserSessionToken: order.restriction.token || '',
              checkPreferredLocation: order.checkPreferredLocation || false,
              isisAddTireStorageField: true
            };
            
            const url = this.helperService.constructQueryParams(`/estimate/${order._id}`, queryParams);
            this.helperService.openPageInNewExistingTab(url, order._id);
            this.postTireStorageCustomEvent('Swap tires', order);
            // this.helperService.openPageInNewExistingTab(`${config.redirectUrl.estimate}/${order._id}?isAddTireStorageField=true`, order._id);
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isSwappingTire = false;
      });
  }

  handleRemoveTire() {
    if (this.isSwappingTire) return;

    const data = {
      customerId: this.customer.customerId,
      vehicleId: this.vehicle.vehicleId,
      tireStorageIds: Object.keys(this.selectedTireStorage),
      createType: 'return',
      tireSwape: true
    };

    this.isRemovingTire = true;
    this.httpService
      .createTireStorageEstimate(data)
      .then(
        (order: any) => {
          if (order) {
            const queryParams = {
              browserSessionToken: order.restriction.token || '',
              checkPreferredLocation: order.checkPreferredLocation || false,
            };
            
            const url = this.helperService.constructQueryParams(`/estimate/${order._id}`, queryParams);
            this.helperService.openPageInNewExistingTab(url, order._id);
            this.postTireStorageCustomEvent('Return tires', order);
            // this.helperService.openPageInNewExistingTab(`${config.redirectUrl.estimate}/${order._id}`, order._id);
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isRemovingTire = false;
      });
  }

  postTireStorageCustomEvent(eventTitle: string, order: any){
    if (this.dataService.isGainSightPXEnabled) {
      const estimateCreated: any = {
        roCreationSource: `Vehicle side panel-Tire storage modal ${eventTitle}`,
        roNumber: order.code || '',
      };

      this.helperService.postGainsightPXEvent('RO Created', estimateCreated);
    }
  }

  openTireStorageDialog(tireStorageId: string) {
    this.dataService.sendData(
      this.dataService.typePassData('open-item-dialog', {
        type: 'tireStorage',
        isDisabled: true,
        payload: tireStorageId,
      })
    );
  }
}
